// eslint-disable-next-line complexity
const logoMapper = (siteName, logoBrandName) => {
    let logo;
    let landingPageLogo;
    if (typeof logoBrandName !== 'undefined') {
        logo = `https://csvcus.homeaway.com/rsrcs/cdn-logos/5.8.0/sitename/${logoBrandName}/web/logo.svg`;
        landingPageLogo = `https://csvcus.homeaway.com/rsrcs/cdn-logos/5.8.0/sitename/${logoBrandName}/web/logo-white.svg`;
    } else {
        logo = 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.8.0/sitename/vrbo/web/logo.svg';
        landingPageLogo = 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.8.0/sitename/vrbo/web/logo-white.svg';
    }

    let isDefaultLogo;
    switch (siteName) {
        case 'abritel' :
        case 'homeaway_de' :
        case 'homeaway_au' :
        case 'homeaway_nz' :
        case 'vrbo' :
        case 'vr' :
        case 'homeaway_br' :
            isDefaultLogo = false;
            break;
        case 'homeaway_it' :
        case 'homeaway_es' :
        case 'homeaway_pt' :
        case 'homeaway_sg' :
        case 'homeaway_jp' :
        case 'homeaway_se' :
        case 'homeaway_no' :
        case 'homeaway_dk' :
        case 'homeaway_fi' :
        case 'homeaway_pl' :
        case 'homeaway_at' :
        case 'homeaway_gr' :
        case 'homeaway_lk' :
        case 'homeaway_us' :
        case 'homeaway_uk' :
            logo = 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.8.0/sitename/vrbo/web/logo.svg';
            landingPageLogo = 'https://csvcus.homeaway.com/rsrcs/cdn-logos/5.8.0/sitename/vrbo/web/logo-white.svg';
            isDefaultLogo = true;
            break;
        default:
            isDefaultLogo = true;
            break;
    }

    return {
        logo,
        landingPageLogo,
        isDefaultLogo
    };
};

export default logoMapper;
